import { createCRUDHook } from './createCRUDHook';
import { CarrierDto } from 'utils/models';
import { TLKP_CARRIER } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<CarrierDto>({
  entityName: 'Carrier',
  endpoint: TLKP_CARRIER,
});

export const CarrierContext = Context;
export const useCarrierManager = useManager;
export const useCarrier = useConsumer;
